import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles } from "@mui/styles";
import { useGA4React } from "ga-4-react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetData } from "../../features/data/data.slice";
import { resetFiles } from "../../features/fileUpload/fileUpload.slice";
import { resetSteps } from "../../features/stepper.slice";
import { resetSubmition } from "../../features/submition/submition.slice";
import { Report, ReportPageView } from "../../libs/loggers";
import { useTitle } from "../../providers/titleProvider";
import DropdownInfoBlock from "../ui/feedback/dropdownInfoBlock";
import InvestNowStepper from "../ui/investNowStepper";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  rootLoader: {
    textAlign: "center",
    margin: theme.spacing(2),
  },
  circle: {
    strokeLinecap: "round",
  },
}));

function FinaliseInvestment() {
  const classes = useStyles();
  const { setTitle } = useTitle();
  const [open, setOpen] = useState(false);
  let ga4React = useGA4React();
  const dispatch = useDispatch();
  const stepper = useSelector((state) => state.stepper.value);
  const navigate = useNavigate();

  const submitting = useSelector((state) => state.submition.submition?.loading);
  const userId = useSelector((state) => state.submition.data?.userId);
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  let page = window.location.pathname.replace(/^\/|\/$/g, "");

  const creatingSecureProcess = useSelector(
    (state) => state.submition.submition?.secureProcessLoading
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let page = window.location.pathname.replace(/^\/|\/$/g, "");
    ReportPageView(page, userId, submitionId);
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      dispatch(resetSubmition());
      dispatch(resetData());
      dispatch(resetSteps());
      dispatch(resetFiles());
      navigate("/");
      // e.preventDefault();
      // e.returnValue = "";
    });

    return () => {
      window.removeEventListener("beforeunload", () => {
        alert("user left");
      });
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    if (ga4React) {
      ga4React.event(
        "watch_video",
        "https://downloads.fairtreeinvest.co.za/how-to-sign-digital-signature.mp4",
        "how_to_sign_digital_signature"
      );
    }
    const eventInfo = {
      action: "view",
      category: "video",
      description: "view video",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        url: "https://downloads.fairtreeinvest.co.za/how-to-sign-digital-signature.mp4",
        value: "view_video",
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpen(true);
  };
  useEffect(() => {
    setTitle("Finalise Investment");
  }, [setTitle]);

  const onValidation = async () => {
    return true;
  };
  const handleNext = () => {};
  const theme = useTheme();
  const isLightMode = useMediaQuery("(prefers-color-scheme: light)");
  const mode = isLightMode ? "black" : "white";
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const appMode = isLightMode ? "white" : "black";
  const BootstrapDialogTitle = () => {
    return (
      <DialogTitle variant="h4">
        How to sign your documents
        <IconButton
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
    );
  };

  const openLoader = () => {
    if (submitting || creatingSecureProcess) {
      return true;
    } else {
      return false;
    }
  };
  const stepperContent = () => {
    return (
      <Box className={classes.root}>
        <Typography variant="h4" mb={3} mt={3}>
          Thank you for your submission! You're one step away.
        </Typography>
        <Typography variant={"h5"} fontWeight={500} mb={2}>
          What's Next:
        </Typography>

        <Box display={"flex"} alignItems={"center"} mb={3}>
          <img
            width={"60px"}
            height={"auto"}
            src={`https://s3.af-south-1.amazonaws.com/s3.fairtreewealth.com/public/invest+now+icons/endowement_${mode}.png`}
            alt=""
          />
          <Typography variant={"body1"} sx={{ ml: 2 }}>
            Your application and supporting documents have been sent to one of
            our skilled consultants, who will tend to it shortly.
          </Typography>
        </Box>

        <Box display={"flex"} alignItems={"center"} mb={3}>
          <img
            width={"60px"}
            height={"auto"}
            src={`https://s3.af-south-1.amazonaws.com/s3.fairtreewealth.com/public/invest+now+icons/message_${mode}.png`}
            alt=""
          />
          <Typography variant={"body1"} sx={{ ml: 2 }}>
            You will receive an email from clientservices@fairtreeinvest.com
            with a secure link to your document, Please use that link to
            digitally sign your application.
          </Typography>
        </Box>

        <Box display={"flex"} alignItems={"center"} mb={3}>
          <img
            width={"60px"}
            height={"auto"}
            src={`https://s3.af-south-1.amazonaws.com/s3.fairtreewealth.com/public/invest+now+icons/communication_${mode}.png`}
            sx={{ mr: 4 }}
            alt=""
          />
          <Typography variant={"body1"} sx={{ ml: 2 }}>
            Once signed, our investment consultants will process your
            application and be in touch.
          </Typography>
        </Box>

        <Box
          display="flex"
          flexDirection={"row"}
          alignItems={"center"}
          mb={1}
          sx={{ cursor: "pointer" }}
          onClick={handleOpen}
        >
          <InfoOutlinedIcon
            color="primary"
            sx={{ mr: "8px", fontSize: "0.8rem" }}
          />
          <Typography color="primary" variant={"p"}>
            Watch this short video about how to digitally sign your documents
          </Typography>
        </Box>

        <DropdownInfoBlock
          title="Turn around time"
          content="
            Any instruction received after 13:00 on a business day will be
            processed on the next business day. Please note that our turn around times can take up to 2 business
            days."
          defaultOpen={false}
        />
        <Dialog sx={{ overflow: "hidden" }} onClose={handleClose} open={open}>
          <BootstrapDialogTitle id="customized-dialog-title" />

          <ReactPlayer
            playing={open}
            url="https://downloads.fairtreeinvest.co.za/how-to-sign-digital-signature.mp4"
            width={"100"}
            controls={open}
            style={{ overflow: "hidden" }}
          />
        </Dialog>

        <Dialog
          fullWidth
          open={openLoader()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{
            classes: {
              rootLoader: classes.backDrop,
            },
          }}
        >
          {" "}
          <Box margin={"auto"}>
            {" "}
            <img
              src={`https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_${appMode}_Excellence.png`}
              height="200px"
              width="200px"
              margin="auto"
              alt=""
            />
          </Box>
          <Box m={3} mt={0}>
            {submitting && (
              <div className={classes.rootLoader}>
                <CircularProgress
                  color="primary"
                  variant="indeterminate"
                  disableShrink
                  className={classes.top}
                  classes={{
                    circle: classes.circle,
                  }}
                  size={70}
                  thickness={4}
                />

                <Typography variant={isMobile ? "h5" : "h4"}>
                  Thank you, we are submitting your request. <br /> This may
                  take a moment.
                </Typography>
              </div>
            )}

            {creatingSecureProcess && (
              <div className={classes.rootLoader}>
                <CircularProgress
                  color="primary"
                  variant="indeterminate"
                  disableShrink
                  className={classes.top}
                  classes={{
                    circle: classes.circle,
                  }}
                  size={70}
                  thickness={4}
                />

                <Typography variant={isMobile ? "h5" : "h4"}>
                  {"Creating Secure Process..."}
                </Typography>
              </div>
            )}
          </Box>
        </Dialog>
      </Box>
    );
  };

  return (
    <InvestNowStepper
      selectedStep={4}
      getStepContent={() => stepperContent()}
      checkValidation={() => onValidation()}
      onNext={() => handleNext()}
    />
  );
}

export default FinaliseInvestment;
